var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('register-banner'),_c('register-feature-list'),_c('register-feature-description'),_c('Testimonials'),_c('call-to-action')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }